import { render, staticRenderFns } from "./ProfileMarathonGift.vue?vue&type=template&id=e25170ec"
import script from "./ProfileMarathonGift.vue?vue&type=script&lang=js"
export * from "./ProfileMarathonGift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports